import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { DatePipe } from '@angular/common';
import { UploadService } from './../d-i/upload.service';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'document-repository',
  templateUrl: './document-repository.component.html',
  styleUrls: ['./document-repository.component.css']
})
export class DocumentRepositoryComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  @ViewChild(NgSelectComponent, { static: false })
  ngSelect: NgSelectComponent;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string;
  chapterId: number;
  createdBy: any = this.loginData.userId;
  createdDateTime: any;
  modifiedBy: any = this.loginData.userId;
  modifiedDateTime: any;
  userId: any = this.loginData.userId;
  adminId: any = localStorage.getItem('adminId');
  numberOfElements: number;
  currentPage = 0;
  currentNumberOfElements = 10;
  totalPages = 0;
  roleList: any;
  tableShow: any;
  limit = 10;
  currentShowingElements = 10;
  searchKey: any;
  searchTerm: any;
  siteData: any;
  siteList: any;
  siteListSearch: any;
  selectedBpgsData: any;
  bpgList: any;
  bpgListSearch: any;
  selectedSiteId: any = Number(localStorage.getItem('userSiteId'));
  selectedBpgSearch: any;
  selectedErgId: any;
  selectedSite: any;
  selectedSiteSearch: any;

  siteAndPath: any;
  selectedBpg: any;
  allBpgIds: any;
  allSiteIds: any;
  landingData: any;
  loginUserAdminId: any = localStorage.getItem('adminId');
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginDataDetails: any = JSON.parse(localStorage.getItem('loginData'));
  eventPicture = true;
  uploadFileName: string = null;
  uploadFileExtension = false;
  width: number;
  height: number;
  lbl: any;
  uploadedFile: string = null;
  action = "";
  fileExtensionError = false;
  fileSizeExtensionError = false;
  selectedFile: File = null;
  uploadFileSizeConstant = "Upload < 500MB";
  selectedFileName: string = this.uploadFileSizeConstant;
  fileName = "";
  fileExtension: any;
  fileSize: number;
  fileList: File[] = [];
  eventList: any;
  eventId: number;
  selectedSiteIdSearch: any = 0;
  selectedErgIdSearch: any = 0;
  page = 0;
  isFileUploded = false;
  galleryItemsList: any = null;
  selectAllConstant = 'Select All';
  chapterList: any;
  chapterIds: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  awsUrls: any;
  galleryList: any;
  uploadFlag: any = "gallery";
  errorMsgUploadSave = false;
  leadAdminId: any = localStorage.getItem('leadAdminId');
  userAndRoleIdDTO: any;
  documentName: any;
  allowedExtensions: any = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
  typeList: any[] = [{ type: this.selectAllConstant }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
  filterType: any = "document";
  folderList: any;
  selectedFolder: any;
  folderListForSearch: any;
  selectedFolderForSearch: any;
  folderName: any;
  folderId: any;
  editandSavebtn: any;
  savebtn: any;
  galleryId: any;
  alertUpdateSuccess: any;
  firstEdit = false;
  managerFolderSiteId: string = localStorage.getItem('siteId');
  managerFolderBpgId: string = localStorage.getItem('bpgId');
  isbpgAdmin = false;
  isbpgLeadAdmin =false;
  constructor(private readonly userService: SelfService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly router: Router,
    private readonly environment: EnvironmentConfiguration,
    private readonly datePipe: DatePipe, private readonly uploadService: UploadService) { }

  ngOnInit() {
    this.editandSavebtn = false;
    this.savebtn = true;
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }

    localStorage.removeItem('searchedEventsCaledarItems');

    this.spinner.show();
    this.logUserAction();
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
}
if(localStorage.getItem('isbpgLeadAdmin') === 'true'){
   this.isbpgLeadAdmin = true;
}
    sessionStorage.removeItem("MembershipData");
    if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
      localStorage.setItem('adminId', '2');

    }

    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')

    }
    this.bpgCommonService.getSessionToken();
    if (this.loginUserAdminId === "3" || this.loginUserAdminId === "2" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
        this.chapterList = data;
        if (this.chapterList.length > 1) {
          this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
        }
        for (let i = 0; i < this.chapterList.length; i++) {
          if (i === 0) {
            this.chapterIds = this.chapterList[i].chapterId;
          }
          else {
            this.chapterIds = `${this.chapterIds},${this.chapterList[i].chapterId}`;
          }
        }

        this.siteData = {
          "filter": {
            chapterId: this.chapterIds
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "",
          "searchTerm": "",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "",
          "uid": ""
        }
        this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
          this.siteList = data;
          this.siteListSearch = data
          //filter default site from sitelist
          this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
          this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

          this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });

          for (let i = 0; i < this.siteList.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteList[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
            }
          }
          for (let i = 0; i < this.siteListSearch.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteListSearch[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
            }
          }
          this.getBpgList();
          this.getBpgListSearch();


        });
      });

      this.getSiteName()
    }
    else if (this.loginUserAdminId === "1") {
      this.getSiteName()

      this.getSiteList();
      this.getBpgList();
      this.getBpgListSearch();
      this.getChapterGalleryList();

    }


    this.loginUserId = this.loginData.userId;

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }
  /** get site name in the dropdown for lead admin
    * @class ConfigureGalleryComponent
    * @method getSiteName
    */
  getSiteName() {
    if (this.managerFolderBpgId === undefined && this.managerFolderSiteId === undefined) {
      this.selectedSite = this.loginData.site.siteName;
    }
    else {

      this.selectedSite = localStorage.getItem('siteName');
    }
  }

  /** get site list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getSiteList
    */
  getSiteList() {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      this.siteListSearch = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

      this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });


      if (this.siteList != null || this.siteListSearch != null) {
        if (this.managerFolderBpgId !== undefined && this.managerFolderSiteId !== undefined) {
          this.selectedSiteId = this.managerFolderSiteId;
        }
        for (const site of this.siteList) {
          if (site.siteId === this.selectedSiteId) {
            this.selectedSite = site.siteName;
          }
        }

        for (const siteSearch of this.siteListSearch) {
          if (siteSearch.siteId === this.selectedSiteId) {
            this.selectedSite = siteSearch.siteName;
          }
        }

        for (let i = 0; i < this.siteList.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteList[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
          }
        }

        for (let i = 0; i < this.siteListSearch.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteListSearch[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
          }
        }

      }
    });
  }


  /** get gallery list
   * @class ConfigureGalleryComponent
   * @method getChapterGalleryList
   */
  getChapterGalleryList() {
    this.spinner.show();
    if (this.selectedSiteIdSearch === 0) {
      this.selectedSiteIdSearch = this.allSiteIds;
    }
    if (this.selectedErgIdSearch === 0) {
      this.selectedErgIdSearch = this.allBpgIds;
    }

    this.landingData = {
      "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch, "type": this.filterType, "folderId": this.selectedFolderForSearch },
      "moduleId": 0,
      "page": this.page,
      "presentRole": "string",
      "searchTerm": "string",
      "size": this.limit,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": "string"
    }
    this.userService.getChapterGalleryList(this.landingData).subscribe(data => {
      this.galleryItemsList = data.content;
      this.numberOfElements = data.totalElements;
      this.spinner.hide();
      if (this.galleryItemsList.length === 0) {
        this.noDataFound = true;
        this.tableShow = false;

      } else {
        this.noDataFound = false;
        this.tableShow = true;
      }
    });
  }


  /** get bpg list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getBpgList
    */
  getBpgList() {
    if (this.managerFolderBpgId !== 'undefined' && this.managerFolderSiteId !== 'undefined') {
      this.selectedErgId = this.managerFolderBpgId;
      this.selectedSiteId = this.managerFolderSiteId;
      this.getDocumentsFolderList();
    }
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "adminId": this.loginUserAdminId,
        "userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if (this.bpgList.length === 0) {
        this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
      }



      if (this.bpgList != null) {

        for (const bpg of this.bpgList) {
          if (bpg.bpgId === this.selectedErgId) {
            this.selectedBpg = bpg.bpgName;
          }
        }

        for (let i = 0; i < this.bpgList.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgList[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
          }
        }
      }

    });
  }


  getBpgListSearch() {
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteIdSearch,
        "adminId": this.loginUserAdminId,
        "userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgListSearch = data;

      if (this.bpgListSearch != null) {
        this.bpgListSearch.unshift({ bpgId: 0, bpgName: this.selectAllConstant });

        for (const list of this.bpgListSearch) {
          if (list.bpgId === this.selectedErgId) {
            this.selectedBpg = list.bpgName;
          }
        }


        for (let i = 0; i < this.bpgListSearch.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgListSearch[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgListSearch[i].bpgId},`;
          }
        }
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {

          this.getChapterGalleryList();
        }
      }


    });
  }

  /** get chapter id
  * @class ConfigureGalleryComponent
  * @method getChapterIds
  */
  getChapterIds() {
    this.landingData = {
      "filter": {
        "bpgId": this.selectedErgId,
        "siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if (data != null) {
        for (const d of data) {
          this.chapterId = d;
        }
      }
    });
  }


  /** For site change from site list
     * @class ConfigureGalleryComponent
     * @method siteChange
     * @returns Promise
     */
  siteChange(event) {
    this.selectedErgId = null;
    this.selectedBpg = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.getBpgList();
    this.eventId = null;
    this.folderId = null;
    this.folderName = null;
    this.selectedFolder = null;
    this.getDocumentsFolderList();

  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChange
    * @returns Promise
    */

  bpgChange(event) {
    this.selectedErgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedErgId = event.bpgId;
    this.getChapterIds();
    this.getDocumentsFolderList();
    this.folderId = null;
    this.folderName = null;
    this.selectedFolder = null;

  }

  public onFileSelected(event) {
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      const allowedExtensions = ["mp3", "xls", "xlsx", "csv", "doc", "docx", "txt", "pdf", "ppt", "pptx", "jpg", "jpeg", "png"];
      this.fileExtension = this.fileName.split('.').pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {

        if (this.fileSize > 524288000) {
          this.fileSizeExtensionError = true;
        } else {
          this.fileExtensionError = false;
          this.fileSizeExtensionError = false;
          this.selectedFile = event.target.files[0] as File;
          this.selectedFileName = this.selectedFile.name;
          this.isFileUploded = true;
        }
      } else {
        this.fileExtensionError = true;
        this.selectedFileName = this.uploadFileSizeConstant;
      }
    }
  }

  /** checks if word exists in array
   * @class ConfigureGalleryComponent
   * @method isInArray
   */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }



  /** For adding 365 days to current day
* @class ConfigureGalleryComponent
* @method addDays
* @params Date, number
*/
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }


  /** to submit resource
   * @class ConfigureGalleryComponent
   * @method onChapterGallerySubmit
   */
  public onDocumentRepositorySubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.alertUpdateSuccess = false;

    this.method = "addGallery";
    this.param = '';
    if (this.editandSavebtn) {
      this.msg1 = " Are you sure you want to update ? ";
    } else {
      this.msg1 = " Are you sure you want to save ? ";
    }

  }


  /** to add new admin
    * @class ConfigureGalleryComponent
    * @method addGallery
    */
  addGallery() {

    //removing special characters from filename
    const str = this.selectedFileName;
    const arr = str.split(".");
    const lastVal = arr.pop();
    const firstVal = arr.join(".");
    this.selectedFileName = `${firstVal.replace(/[&/\\#,+()$~%.'"_:*?<>{}]/g, '')}.${lastVal}`;

    this.timeOutError = false;
    let galleryData = null;
    this.modifiedDateTime = new Date();

    if (this.editandSavebtn !== true) {
      galleryData = {
        "createdBy": this.createdBy,
        "createdDateTime": this.createdDateTime,
        "isActive": true,
        "modifiedBy": this.modifiedBy,
        "modifiedDateTime": this.modifiedDateTime,
        "fileName": this.selectedFileName,
        "bpgId": this.selectedErgId,
        "isEvent": null,
        "siteId": this.selectedSiteId,
        "eventId": null,
        "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        "documentName": this.documentName,
        "folderId": this.selectedFolder
      }
    } else {
      galleryData = {
        "galleryId": this.galleryId,
        "createdBy": this.createdBy,
        "createdDateTime": this.createdDateTime,
        "isActive": true,
        "modifiedBy": this.modifiedBy,
        "modifiedDateTime": this.modifiedDateTime,
        "fileName": this.selectedFileName,
        "bpgId": this.selectedErgId,
        "isEvent": null,
        "siteId": this.selectedSiteId,
        "eventId": null,
        "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        "documentName": this.documentName,
        "folderId": this.selectedFolder
      }
    }
    const uploadData =
    {
      'category': 'uploadDocument',
    }
    //if save condition
    this.action = "CHAPTER_GALLERY";
    this.spinner.show();
    this.userService.addGallery(galleryData).subscribe(data => {
      this.galleryList = data
      if (this.editandSavebtn === true) {
        this.spinner.hide();
        this.alertUpdateSuccess = true;
        this.deleteSuccess = false;
        this.errorMsgUploadSave = false;
        this.alertSuccess = false;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 300);
        setTimeout(() => {
          this.resetGallery()
        }, 1500);
        this.getChapterGalleryList();
      }

      if (data.message !== undefined) {
        this.spinner.hide();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 300);
      }
      else if (data !== undefined) {
        this.spinner.show();
        if (this.selectedFile != null) {
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
            await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.galleryList.fileName, this.uploadFlag);
            if (localStorage.getItem('uploadError') === 'Error') {
              this.userService.deleteGallery(this.galleryList.galleryId).subscribe(_data => {
                this.spinner.hide();

                this.errorMsgUploadSave = true;
                this.alertSuccess = false;
                this.deleteSuccess = false;
                localStorage.removeItem('uploadError')
              });

            } else {

              if (this.editandSavebtn !== true) {
                this.alertSuccess = true;
                setTimeout(() => {
                  this.resetGallery()
                }, 1500);
              }
              this.deleteSuccess = false;
              this.errorMsgUploadSave = false;

              this.getChapterGalleryList();

            }

            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinner.hide();
          }, err => {
            this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
          });
        }
      }

    });

  }


  /** For filtering data by current page
   * @class ConfigureGalleryComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getChapterGalleryList();
  }

  /** Confirm on reset
    * @class ConfigureGalleryComponent
    * @method resetGallery
    */
  resetGallery() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.myInputVariable.nativeElement.value = "";
    this.selectedBpg = null;
    this.selectedErgId = null;
    this.folderId = null;
    this.folderName = null;
    this.selectedFolder = null;
    this.selectedErgIdSearch = null;
    this.selectedSiteIdSearch = null;
    this.searchKey = null;
    this.LandingPaginationDTO.searchTerm = null;
    this.selectedFileName = this.uploadFileSizeConstant;
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.eventId = null;
    this.deleteSuccess = false;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.alertSuccess = false;
    this.selectedFile = null;
    this.isFileUploded = false;
    this.selectedBpgSearch = null;
    this.selectedSiteSearch = null;
    this.errorMsgUploadSave = false;
    this.documentName = "";
    this.selectedSite = this.loginData.site.siteName;
    this.eventPicture = true;
    this.editandSavebtn = false;
    this.savebtn = true;
    this.firstEdit = false;
    this.selectedFolderForSearch = null;


    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.selectedSiteIdSearch = 0;
      this.selectedErgIdSearch = 0;
      this.getBpgListSearch();
    }
    this.getChapterGalleryList();
    this.getBpgList();
  }


  /** For site change from site list
   * @class ConfigureGalleryComponent
   * @method siteChangeSearch
   * @returns Promise
   */
  siteChangeSearch(event) {

    this.selectedSiteIdSearch = event.siteId;
    this.getBpgListSearch();
    this.folderId = null;
    this.folderName = null;
    this.selectedFolderForSearch = null;
    this.getDocumentsFolderListSearch();
  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChangeSearch
    * @returns Promise
    */

  bpgChangeSearch(event) {
    this.selectedErgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedErgIdSearch = event.bpgId;
    this.selectedErgId = event.bpgId;
    this.getChapterIds();
    this.getDocumentsFolderListSearch();
    this.folderId = null;
    this.folderName = null;
    this.selectedFolderForSearch = null;
  }




  /** confirmation to delete gallery
* @class ConfigureGalleryComponent
* @method deleteGalleryConfirmation
*/
  public deleteGalleryConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.alertUpdateSuccess = false;
    this.method = "deleteGallery";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete ? ";
  }

  /** to Delete gallery
* @class ConfigureGalleryComponent
* @method deleteGallery
*/
  deleteGallery(galleryId) {
    this.spinner.show();
    this.userService.deleteGallery(galleryId).subscribe(_data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;
      if (this.galleryItemsList.length === 1 && this.numberOfElements > 10) {
        this.currentPage = 0;
        this.page = 0;
        this.currentShowingElements = 10

      }

      this.getChapterGalleryList();
    });
  }

  downloadDocument(urls, i) {
    const extension = urls.substring(urls.lastIndexOf('.') + 1);
    const link = document.getElementById('downloadFiles' + i);
    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
  }


  /** to reset resource
   * @class ConfigureGalleryComponent
   * @method resetClick
   */
  resetClick() {
    this.method = "resetGallery";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  getChapterGalleryListSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getChapterGalleryList();

  }


  /** get gallery list
 * @class ConfigureGalleryComponent
 * @method getChapterGalleryList
 */
  public getDocumentsFolderList() {
    this.spinner.show();
    if (this.selectedSiteId === 0) {
      this.selectedSiteId = this.allSiteIds;
    }
    if (this.selectedErgId === 0) {
      this.selectedErgId = this.allBpgIds;
    }
    if (this.managerFolderBpgId !== 'undefined' && this.managerFolderSiteId !== 'undefined') {
      this.selectedBpg = this.managerFolderBpgId;
      this.selectedSiteId = this.managerFolderSiteId;
    }
    this.landingData = {
      "filter": { "siteId": this.selectedSiteId, "bpgId": this.selectedErgId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 1000,
      "sortDirection": "ASC",
      "sortProperty": "folder_name",
      "uid": ""
    }
    this.userService.getDocumentsFolderList(this.landingData).subscribe(data => {
      this.folderList = data.content;
      this.spinner.hide();

    });
  }


  /** get gallery list
* @class ConfigureGalleryComponent
* @method getChapterGalleryList
*/
  public getDocumentsFolderListSearch() {
    this.spinner.show();
    if (this.selectedSiteIdSearch === 0) {
      this.selectedSiteIdSearch = this.allSiteIds;
    }
    if (this.selectedErgIdSearch === 0) {
      this.selectedErgIdSearch = this.allBpgIds;
    }

    this.landingData = {
      "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 1000,
      "sortDirection": "ASC",
      "sortProperty": "folder_name",
      "uid": ""
    }
    this.userService.getDocumentsFolderList(this.landingData).subscribe(data => {
      this.folderListForSearch = data.content;
      this.spinner.hide();

    });
  }



  /** to add new admin
   * @class ConfigureGalleryComponent
   * @method addGallery
   */
  updateGallery(data) {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.alertSuccess = false;
    this.alertFailure = false;
    this.editandSavebtn = true;
    this.savebtn = false;
    this.timeOutError = false;
    this.modifiedDateTime = new Date();
    this.modifiedBy = this.loginDataDetails['userId'];
    this.createdBy = this.loginDataDetails['userId'];
    this.createdDateTime = new Date();
    this.selectedFileName = data.originalFileName;
    this.selectedFolder = data.folderId;
    this.folderName = data.folderName;
    this.folderId = data.folderId;

    this.documentName = data.documentName;
    this.selectedBpg = data.bpgName;
    this.selectedErgId = data.bpgId;
    this.selectedSite = data.siteName;
    this.selectedSiteId = data.siteId;
    this.galleryId = data.galleryId;
    this.getDocumentsFolderList();
  }

  public editDocument(data, i) {
    if (this.firstEdit === false) {
      this.firstEdit = true;
      this.updateGallery(data);
    } else {
      document.getElementById('edit' + i).setAttribute('data-toggle', 'modal');
      document.getElementById('edit' + i).setAttribute('data-target', '#myModal');
      this.method = "updateGallery";
      this.param = data;
      this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Chapter Resources Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}
